import { TTransshipmentStepId } from '../../types';

const step = {
  path: 'sucesso',
  next: (): TTransshipmentStepId => 'success-page',
};

export default step;
